import React from 'react';
import CoordinatePatientList from './CoordinatePatientList';

const CoordinateMyPatients: React.FC = () => {
  return <CoordinatePatientList ownershipFilter="MY" />;
};

export default CoordinateMyPatients;
